export const caído = {
	nombre: "Caído",
	dia: "Martes Santo",
	nombrecompleto:
		"Hermandad Sacramental, Venerable y Marianista Cofradía de Penitencia de Nuestro Padre Jesús Caído y María Santísima de los Desamparados",
	sede: "Iglesia de Nuestra Señora de los Remedios ",
	pasos: 2,
	distancia: [1030, 1170],
	penitentes: 225,
	cargadores: 104,
	web: "http://www.diariodecadiz.es/semana_santa/Caido_0_1229277813.html",

	ida: [
		{ lng: -6.2957802, lat: 36.5346701 },
		{ lng: -6.295673, lat: 36.5345451 },
		{ lng: -6.2963006, lat: 36.5342628 },
		{ lng: -6.294525, lat: 36.5322821 },
		{ lng: -6.2940745, lat: 36.5324218 },
		{ lng: -6.2922133, lat: 36.5302949 },
		{ lng: -6.2928379, lat: 36.5297864 },
		{ lng: -6.2936559, lat: 36.5296915 },
		{ lng: -6.2945294, lat: 36.5296271 },
		{ lng: -6.2946095, lat: 36.5295557 },
		{ lng: -6.295056, lat: 36.529573 },
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957025, lat: 36.5291182 },
		{ lng: -6.2954074, lat: 36.5297562 },
		{ lng: -6.2956676, lat: 36.5299588 },
		{ lng: -6.2952921, lat: 36.5303424 },
		{ lng: -6.2950225, lat: 36.5308338 },
		{ lng: -6.2949219, lat: 36.5308392 },
		{ lng: -6.2949246, lat: 36.5314524 },
		{ lng: -6.2964575, lat: 36.5317735 },
		{ lng: -6.2964079, lat: 36.5318425 },
		{ lng: -6.2967995, lat: 36.532544 },
		{ lng: -6.2965822, lat: 36.5327649 },
		{ lng: -6.2962738, lat: 36.5332455 },
		{ lng: -6.2962711, lat: 36.5339373 },
		{ lng: -6.2967807, lat: 36.5341916 },
		{ lng: -6.2964401, lat: 36.5344265 },
		{ lng: -6.2966466, lat: 36.5346291 },
		{ lng: -6.2969792, lat: 36.53478 },
		{ lng: -6.2963033, lat: 36.5353468 },
		{ lng: -6.2952867, lat: 36.535086 },
		{ lng: -6.2955509, lat: 36.5346658 },
		{ lng: -6.2956649, lat: 36.5345666 },
		{ lng: -6.2957668, lat: 36.5346895 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-27T17:50",
			latlng: [36.53466, -6.2958]
		},
		{
			name: "Nueva",
			hora: "2018-03-27T19:25",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-27T20:25",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-27T21:25",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-27T21:50",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-27T22:00",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Plaza Stmo. Cristo de la Vera-Cruz",
			"Plaza San Francisco",
			"Rosario",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañes", "Palillero"],
		["Novena", "Valverde"],
		[
			"San Pedro (izq.)",
			"Sagasta (drch)",
			"Tinte",
			"Plaza Mina (interior por delante del Museo)",
			"Antonio López",
			"Isabel La Católica (dcha.)",
			"Plaza Stmo. Cristo de la Vera-Cruz"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/caído.js